var React = require('react');

function EmptyProfile (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Icon_ionic-ios-person","d":"M27,26.3c-0.5-2.2-3.4-3.3-4.4-3.7c-1.2-0.3-2.4-0.5-3.7-0.7c-0.6-0.1-1.2-0.4-1.7-0.8\n\tc-0.3-0.3-0.1-3.5-0.1-3.5c0.3-0.5,0.6-1,0.8-1.5c0.3-0.9,0.5-1.8,0.6-2.7c0,0,0.6,0,0.8-1c0.3-0.8,0.4-1.6,0.5-2.4\n\tc0-0.8-0.5-0.8-0.5-0.8c0.3-1.2,0.5-2.4,0.5-3.6C19.9,2.8,17.6,0,13.5,0C9.4,0,7.1,2.8,7.2,5.7c0,1.2,0.1,2.4,0.5,3.6\n\tc0,0-0.4,0-0.5,0.8c0.1,0.8,0.3,1.6,0.5,2.4c0.2,1,0.8,1,0.8,1c0.1,0.9,0.3,1.8,0.6,2.7c0.2,0.5,0.5,1,0.8,1.5c0,0,0.2,3.1-0.1,3.5\n\tc-0.5,0.4-1.1,0.7-1.7,0.8c-1.2,0.2-2.5,0.4-3.7,0.7c-1,0.4-3.9,1.4-4.4,3.7c-0.1,0.3,0.1,0.6,0.4,0.7c0,0,0.1,0,0.1,0h25.9\n\tc0.3,0,0.6-0.3,0.6-0.6C27,26.4,27,26.4,27,26.3z"}));
}

EmptyProfile.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 27 27","style":{"enableBackground":"new 0 0 27 27"},"xmlSpace":"preserve"};

module.exports = EmptyProfile;

EmptyProfile.default = EmptyProfile;
